import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { trimOnBlur } from '../trimOnBlur';

interface MaskedInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export default function MaskedInput({ id, label, value, onChange, required }: MaskedInputProps) {
  const [revealed, setRevealed] = useState(false);
  return (
    <div className="field">
      <label className="label" htmlFor={id}>
        {label}
        {required && <> <span className="text-red-500">*</span></>}
      </label>
      {/* The input sits right under .field so it gets the wizard's taller padding (`.field > .input`);
          a wrapper in between would drop it back to the console's compact input. */}
      <input
        id={id}
        type={revealed ? 'text' : 'password'}
        className="input !pr-11"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        // Padding comes off on blur like every other box (OM-4602). Masked or not, the value is
        // operator-typed text, and submit has always trimmed it — this keeps what is revealed
        // behind the eye the same as what gets stored.
        onBlur={trimOnBlur(onChange)}
      />
      <button
        type="button"
        aria-label={revealed ? `Hide ${label}` : `Show ${label}`}
        onClick={() => setRevealed((r) => !r)}
        className="absolute bottom-0 right-0 top-2.5 flex items-center px-3 text-content-secondary"
      >
        {revealed ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
}
